import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const Module4b2 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module4b2;

    const textes = [texts.lang41, texts.lang42, texts.lang43, texts.lang44, texts.lang45];
    const [isShown, setIsShown] = useState(false);

    const [text, setText] = useState("0");

    const [playSound, setPlaySound] = useState(false);

    const buttons = [];
    //Add a sound button
    buttons.push(
        <div key={1}
            onMouseEnter={
                () => { setIsShown(true) }
            }
            onMouseLeave={
                () => { setIsShown(false) }
            }
            onClick={
                () => {
                    if (playSound) {
                        clearAll();
                        setPlaySound(false);
                    }
                    else {
                        setPlaySound(true);
                    }
                }}
            style={{
                cursor: "pointer",
            }}
        >
            <ImageButton id="2"
                x="0"
                y="10"
                dirName="module4b2"
            />
            {(isShown || !playSound) && < ImageButton id="3"
                x="0"
                y="10"
                dirName="module4b2" />}
        </div>
    );

    const clearAll = () => {
        //pause all audios in props.audio
        props.audio.forEach(audio => {
            audio.pause();
            audio.currentTime = 0;
        });
    }

    return (
        <div className="background" >
            <div
                style={{
                    position: 'absolute',
                    top: 30, //offset
                }}
            >
                <img src={process.env.PUBLIC_URL + "/assets/images/module4b2/1.png"}
                    alt="image"
                    style={
                        {
                            position: "absolute",
                            left: 0,
                            top: 10,
                            height: 380,
                            width: 660,
                        }}
                />
                <div className="buttons"
                    style={
                        {
                            position: "absolute",
                            left: 560,
                            top: 30
                        }} >
                    {buttons}
                </div>
                {text != "0" &&
                    <div className="text"
                        style={
                            {
                                position: "absolute",
                                left: 243,
                                top: 36,
                                width: 289,
                                backgroundColor: "#ffcb63",
                                opacity: 0.8,
                                border: "1px solid black",
                            }}
                    >
                        <p style={
                            {
                                fontSize: "0.8em",
                                color: "black",
                                margin: "4px 4px",
                                opacity: 1
                            }} >
                            {
                                text != "0" ? textes[text - 1] : ""
                            }
                        </p>
                    </div>}
                <div className="rect1"
                    style={
                        {
                            position: "absolute",
                            left: 131,
                            top: 25,
                            width: 34,
                            height: 46,
                            backgroundColor: "orange",
                            opacity: text == "1" ? 0.4 : 0,
                            border: "1px solid black",
                            cursor: "pointer"
                        }}
                    onMouseEnter={
                        () => setText("1")}
                    onMouseLeave={
                        () => setText("0")}
                    onClick={() => {
                        clearAll();
                        //play mp3 file
                        if(!playSound) return;
                        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module4b_1.mp3");
                        audio.play();
                        props.audio.push(audio)
                    }}
                />
                <div className="rect2"
                    style={
                        {
                            position: "absolute",
                            left: 178,
                            top: 25,
                            width: 34,
                            height: 46,
                            backgroundColor: "orange",
                            opacity: text == "2" ? 0.4 : 0,
                            border: "1px solid black",
                            cursor: "pointer"
                        }}
                    onMouseEnter={
                        () => setText("2")}
                    onMouseLeave={
                        () => setText("0")} > </div>
                <div className="rect3"
                    style={
                        {
                            position: "absolute",
                            left: 134,
                            top: 124,
                            width: 337,
                            height: 47,
                            backgroundColor: "orange",
                            opacity: text == "3" ? 0.4 : 0,
                            border: "1px solid black",
                            cursor: "pointer"
                        }}
                    onMouseEnter={
                        () => setText("3")}
                    onMouseLeave={
                        () => setText("0")}
                    onClick={() => {
                        clearAll();
                        //play mp3 file
                        if(!playSound) return;
                        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module4b_2.mp3");
                        audio.play();
                        props.audio.push(audio)
                    }} />
                <div className="rect4"
                    style={
                        {
                            position: "absolute",
                            left: 134,
                            top: 228,
                            width: 342,
                            height: 49,
                            backgroundColor: "orange",
                            opacity: text == "4" ? 0.4 : 0,
                            border: "1px solid black",
                            cursor: "pointer"
                        }}
                    onMouseEnter={
                        () => setText("4")}
                    onMouseLeave={
                        () => setText("0")}
                    onClick={() => {
                        clearAll();
                        //play mp3 file
                        if(!playSound) return;
                        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module4b_3.mp3");
                        audio.play();
                        props.audio.push(audio)
                    }} />
                <div className="rect5"
                    style={
                        {
                            position: "absolute",
                            left: 129,
                            top: 329,
                            width: 348,
                            height: 54,
                            backgroundColor: "orange",
                            opacity: text == "5" ? 0.4 : 0,
                            border: "1px solid black",
                            cursor: "pointer"
                        }}
                    onMouseEnter={
                        () => setText("5")}
                    onMouseLeave={
                        () => setText("0")}
                    onClick={() => {
                        clearAll();
                        //play mp3 file
                        if(!playSound) return;
                        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module4b_4.mp3");
                        audio.play();
                        props.audio.push(audio)
                    }}
                >
                </div>
            </div>

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className='t1'
                style={{
                    position: 'absolute',
                    left: 291,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15,
                }}
            >{texts.lang30}</p>
            <p
                className='t2'
                style={{
                    position: 'absolute',
                    left: 5,
                    top: 410,
                    color: 'white',
                    fontSize: '14px',
                    zIndex: 15,
                }}
            >{texts.lang31}</p>
            <p
                className='t2'
                style={{
                    position: 'absolute',
                    left: 5,
                    top: 443,
                    width: 380,
                    color: 'white',
                    fontSize: '14px',
                    zIndex: 15,
                }}
            >{texts.lang32}</p>
        </div>
    );
}

export default Module4b2;